import { gql } from '@apollo/client';
/**
 * @const CreateDealMessageMutation
 * @since 1.0.0
 */
export const CreateDealMessageMutation = gql `
  mutation CreateDealMessageMutation($input: CreateDealMessageInput!) {
    createDealMessage(input: $input) {
      message
      date
      user {
        firstname
        lastname
      }
    }
  }
`;
